import $ from "jquery"
import Hook from "../../hook"

/** Custom hook for variphone */
class QuickCartHook extends Hook {
  /**
   * Add Price condition event
   * @param {Window} window - Window
   * @returns {Promise} Promise
   */
  async afterRender(window) {
    if (
      window.output.Request.Subject != "Sales.CUST_QuickCart" ||
      window.output.Request.Prefix != "New"
    ) {
      return
    }

    window.customData = {}

    // Default, disable AddressID and DimensionObjectID, enable if CustomerID is changed
    let $customerID = $("[name='CustomerID']")
    $customerID
      .change(async () => {
        window.customData.CustomerID = $customerID.val()

        if ($customerID.val()) {
          $("input", $("[name='AddressID']").closest(".form-field")).prop(
            "disabled",
            false,
          )
          $(
            "input",
            $("[name='DimensionObjectID']").closest(".form-field"),
          ).prop("disabled", false)
        } else {
          $("input", $("[name='AddressID']").closest(".form-field")).prop(
            "disabled",
            true,
          )
          $(
            "input",
            $("[name='DimensionObjectID']").closest(".form-field"),
          ).prop("disabled", true)
        }
      })
      .change()

    // Create 'openDimensionObjectModal'-button
    let $dimensionObjectID = $(
      "[data-toggle-combobox='data-toggle-combobox']",
      $("[name='DimensionObjectID']", $(window.element)).parent(".combobox"),
    )
    $(
      '<div id="openDimensionObjectModal" class="ref-button button material-icons" style="font-size:13px; right: 24px; line-height: initial;;" data-toggle-modal dimensiontabindex="-1"> \
				<i class="fas fa-clipboard-list" style="pointer-events:none;"></i> \
			</div>',
    ).insertAfter($dimensionObjectID)

    // Default, hide all options
    let $opts = $("[name*='Soft OptionID-']", $(window.element)).add(
      $("[name*='Hard OptionID-']", $(window.element)),
    )
    $opts.each(function() {
      $(this)
        .closest(".form-field")
        .parent()
        .hide()
    })

    let $inputSoftItem = $("[name='Soft ItemID']", window.element)
    $inputSoftItem
      .change(async () => {
        let availableOptions = await window.session.request(
          "/OptionWebService.asmx/AvailableOptions",
          {itemID: $inputSoftItem.val()},
        )

        // Default, show or hide all options
        let $opts = $("[name*='Soft OptionID-']", $(window.element))
        $opts.each(function() {
          let optionID = +$(this)
            .attr("name")
            .replace("Soft OptionID-", "")
          if ($.inArray(optionID, availableOptions) > -1) {
            $(this)
              .closest(".form-field")
              .parent()
              .show()
          } else {
            $(this)
              .closest(".form-field")
              .parent()
              .hide()
          }
        })
      })
      .change()

    let $inputHardItem = $("[name='Hard ItemID']", window.element)
    $inputHardItem
      .change(async () => {
        let availableOptions = await window.session.request(
          "/OptionWebService.asmx/AvailableOptions",
          {itemID: $inputHardItem.val()},
        )

        // Default, show or hide all options
        let $opts = $("[name*='Hard OptionID-']", $(window.element))
        $opts.each(function() {
          let optionID = +$(this)
            .attr("name")
            .replace("Hard OptionID-", "")
          if ($.inArray(optionID, availableOptions) > -1) {
            $(this)
              .closest(".form-field")
              .parent()
              .show()
          } else {
            $(this)
              .closest(".form-field")
              .parent()
              .hide()
          }
        })
      })
      .change()
  }
}

/** @ignore */
export default new QuickCartHook()
